import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from 'emotion';

const drawerPageGroupStyle = css`
  width: 100vw;
  height: 100%;
  overflow: hidden;
  display: block;
  position: relative;
`;

const pageWrapper = css`
  display: block;
  position: absolute;
  width: 100%;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  transform: translateX(100vw);
  transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
`;

const pageWrapperActiveStyle = css`
  transform: translateX(0);
`;

const pageWrapperMainStyle = css`
  transform: translateX(-100vw);
`;

/**
 * A container for multiple drawer pages
 * @param {any} props
 */

const DrawerPageGroup = ({ activePage, children, mainPage }) => (
  <div className={drawerPageGroupStyle}>
    {children.map((page) => {
      const isMainPage = page.props.pageName === mainPage;
      const isActivePage = page.props.pageName === activePage;

      return (
        <div
          className={cx(pageWrapper, {
            [pageWrapperMainStyle]: isMainPage,
            [pageWrapperActiveStyle]:
              isActivePage || (!activePage && isMainPage),
          })}
          key={page.key}
        >
          {page}
        </div>
      );
    })}
  </div>
);

DrawerPageGroup.defaultProps = {
  activePage: null,
  mainPage: 'main',
};

DrawerPageGroup.propTypes = {
  children: PropTypes.node.isRequired,
  activePage: PropTypes.string,
  mainPage: PropTypes.string,
};

export default DrawerPageGroup;
